var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"micro-animation"},[_c('div',{staticClass:"play-video-box"},[(_vm.isshowVideo)?_c('div',{staticClass:"prism-player",attrs:{"id":"J_prismPlayer"}}):_vm._e(),_c('div',{staticClass:"video-controls"},[_c('em',{staticClass:"controls-btn",class:{
          'pause-icon': _vm.plsyStatus == 'play',
          'play-icon': _vm.plsyStatus == 'paused',
          'replay-icon': _vm.plsyStatus == 'ended',
        },on:{"click":_vm.changeType}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }